// extracted by mini-css-extract-plugin
export var header = "Header-module--header--18973";
export var headline = "Header-module--headline--4697b";
export var label = "Header-module--label--81f9a";
export var labels = "Header-module--labels--e0d0e";